import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

function RemainingInvitesMessage({ remainingInvites, timeRemaining }) {
    return (
        <div className="field__message">
            <FormattedMessage
                id="send_message_description"
                values={{
                    time_remaining: timeRemaining,
                    remaining_invites: remainingInvites,
                }}
            />
        </div>
    );
}

export default RemainingInvitesMessage;

RemainingInvitesMessage.propTypes = {
    remainingInvites: PropTypes.number.isRequired,
    timeRemaining: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/apps/invite-designer/components/RemainingInvitesMessage.jsx